var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company-mobile-taken-list',{attrs:{"loading":_vm.loading,"groups":_vm.groups,"title":_vm.$t('taken'),"search":_vm.search,"show-taken":_vm.canCheckReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }